import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

// Ruční příjemka bez faktury (§7). Cílový sklad = vybraný sklad vlevo.
export function ManualReceiptDialog({ warehouse, busy, onSubmit, onClose }) {
  const [name, setName] = useState("");
  const [unit, setUnit] = useState("ks");
  const [qty, setQty] = useState("");
  const [unit_price, setPrice] = useState("");
  const [note, setNote] = useState("");
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="manual-dialog">
        <DialogHeader><DialogTitle>Ruční příjemka — {warehouse?.name}</DialogTitle></DialogHeader>
        <div className="space-y-3.5">
          <div>
            <Label>Název položky *</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="manual-name" placeholder="Např. Cement 25 kg" />
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div><Label>MJ</Label><Input value={unit} onChange={(e) => setUnit(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="manual-unit" /></div>
            <div><Label>Množství *</Label><Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="manual-qty" /></div>
            <div><Label>Cena/MJ</Label><Input type="number" step="0.01" value={unit_price} onChange={(e) => setPrice(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="manual-price" /></div>
          </div>
          <div>
            <Label>Poznámka</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="manual-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={() => onSubmit({ name, unit, qty, unit_price, note })} disabled={busy || !name.trim() || !qty} data-testid="manual-confirm">
            {busy ? "Ukládám…" : "Naskladnit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
